import type { ReactNode } from "react";
import { useAuth } from "@repo/auth";
import { Forbidden } from "../../pages/Forbidden";

/** The Keycloak realm role gating the operator surface (super-admin.md tech decision). */
export const OPERATOR_ROLE = "platform-operator";

/** True when the current identity holds the `platform-operator` realm role (advisory, server re-checks). */
export function isPlatformOperator(realmRoles: readonly string[]): boolean {
  return realmRoles.some((r) => r.toLowerCase() === OPERATOR_ROLE);
}

/**
 * ADVISORY guard for the operator back office (super-admin.md). The whole `/ops` subtree is a NEW
 * top-level area gated on the `platform-operator` realm role — NOT venue-scoped. Purely presentational:
 * the backend gates every `/api/v1/ops/**` route on the same role and re-checks at action time, so a
 * stale/absent claim only ever hides chrome. An operator token carries NO tenant claim (R5).
 */
export function RequireOperator({ children }: { children: ReactNode }) {
  const { claims } = useAuth();
  if (!isPlatformOperator(claims.realmRoles)) return <Forbidden />;
  return <>{children}</>;
}
